
export const baseApiUrl = 'https://qualidonto.intelite.com.br/api/'
// export const baseApiUrl = 'http://localhost:3002/api/'
export const userKey = '__orale_user'
export const operadora = {
    nome: "Qualidonto",
    nomeMaiusculo: "QUALIDONTO",
    corPrincipal: "#0098DA",
    corSecundaria: "#00A859",
    numeroAns: 417131,
    usaCupomDesconto: true,
    usaPagamentoMensalBoleto: true,
    usaPagamentoMensalCartao: true,
    usaPagamentoAnualBoleto: true,
    usaPagamentoAnualCartao: true,
    usaPagamentoAnualParceladoCartao: true,
}

export const modelBoleto = {
    pagadorDocumentoTipo: 1,
    pagadorDocumentoNumero: '',
    pagadorNome: '',
    pagadorEndereco: '',
    pagadorBairro: '',
    pagadorCidade: '',
    pagadorUf: '',
    pagadorCep: '',
    dataVencimento: '',
    valorNominal: 0,
    multaPercentual: 0,
    multaQuantidadeDias: 0,
    jurosPercentual: 0,
    tipoDesconto: 0,
    descontoValor: 0,
    descontoDataLimite: '',
    valorAbatimento: 0,
    tipoProtesto: 0,
    protestoQuantidadeDias: 0,
    baixaQuantidadeDias: 0,
    mensagem: '',
    tipoTitulo: 4,
    nsu: '',
    nossoNumero: 0,
    seuNumero: '',
    convenioId: 'e496a484-5013-4928-b24c-838f1f5648e7'
}

export default { baseApiUrl, modelBoleto, operadora }